import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { useModal } from "../ModalContext";
import { doc, onSnapshot, setDoc, getDoc } from "firebase/firestore";
import GlassLoader from "../components/ui/GlassLoader";

function UserPage() {
  const { username } = useParams();
  const navigate = useNavigate();
  const currentUser = localStorage.getItem("user");
  

  useEffect(() => {
  if (!currentUser) return;

  const setOnlineStatus = async (isOnline) => {
    await setDoc(doc(db, "users", currentUser), {
      online: isOnline,
      lastSeen: Date.now()
    }, { merge: true });
  };

  // зашёл → онлайн
  setOnlineStatus(true);

  const handleUnload = () => setOnlineStatus(false);

  window.addEventListener("beforeunload", handleUnload);

  return () => {
    setOnlineStatus(false);
    window.removeEventListener("beforeunload", handleUnload);
  };
}, [currentUser]);

  const [userData, setUserData] = useState(null);
  const [isContact, setIsContact] = useState(false);

  const { setPostModal } = useModal();

  // 🔥 эффекты кнопок
  const buttonEffects = {
    onMouseEnter: (e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.15)";
      e.currentTarget.style.transform = "translateY(-1px)";
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.08)";
      e.currentTarget.style.transform = "translateY(0)";
    },
    onMouseDown: (e) => {
      e.currentTarget.style.transform = "scale(0.95)";
    },
    onMouseUp: (e) => {
      e.currentTarget.style.transform = "scale(1)";
    }
  };

  const formatLastSeen = (timestamp) => {
  const diff = Date.now() - timestamp;

  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 1) return "только что";
  if (minutes < 60) return `${minutes} мин назад`;
  if (hours < 24) return `${hours} ч назад`;
  return `${days} дн назад`;
};

  // 🔄 загрузка пользователя
useEffect(() => {
  if (!username) return;

  // 👤 слушаем профиль пользователя
 const unsubUser = onSnapshot(doc(db, "users", username), (snap) => {
  if (snap.exists()) {
    const data = snap.data();

    const safePosts = (data.posts || []).map(p => ({
      ...p,
      comments: p.comments || [],
      likes: p.likes || []
    }));

    setUserData({
      ...data,
      status: data.status || "",
      bio: data.bio || "",
      name: data.name || "",
      posts: safePosts
    });
  }
});

  // 👤 слушаем ТВОИ контакты
  const unsubMe = onSnapshot(doc(db, "users", currentUser), (snap) => {
    if (snap.exists()) {
      const contacts = snap.data().contacts || [];
      setIsContact(contacts.includes(username));
    }
  });

  return () => {
    unsubUser();
    unsubMe();
  };
}, [username, currentUser]);

  // ➕ добавить
  const addToContacts = async () => {
    const myRef = doc(db, "users", currentUser);
    const snap = await getDoc(myRef);

    if (!snap.exists()) return;

    const data = snap.data();
    const contacts = data.contacts || [];

    if (contacts.includes(username)) return;

    const updated = [...contacts, username];

    await setDoc(myRef, { contacts: updated }, { merge: true });
    setIsContact(true);
  };

  // ❌ удалить
  const removeFromContacts = async () => {
    const myRef = doc(db, "users", currentUser);
    const snap = await getDoc(myRef);

    if (!snap.exists()) return;

    const data = snap.data();
    const contacts = (data.contacts || []).filter(u => u !== username);

    await setDoc(myRef, { contacts }, { merge: true });
    setIsContact(false);
  };

if (!userData) {
  return <GlassLoader />;
}

  return (
  <div style={{ ...styles.container, ...styles.pageEnter }}>
      <div style={styles.content}>

        {/* 🔝 TOP BAR */}
        <div style={styles.topBar}>

          <div style={styles.leftBtns}>
            <button
              onClick={() => navigate(-1)}
              style={styles.glassBtn}
              {...buttonEffects}
            >
              ← Назад
            </button>

            <button
              onClick={() => navigate("/")}
              style={styles.glassBtn}
              {...buttonEffects}
            >
              Домой
            </button>
          </div>

          {isContact ? (
            <button style={styles.dangerBtn} onClick={removeFromContacts}>
              Удалить из контактов
            </button>
          ) : (
            <button
              style={styles.glassBtn}
              onClick={addToContacts}
              {...buttonEffects}
            >
              + В контакты
            </button>
          )}

        </div>

        {/* 👤 ПРОФИЛЬ */}
       <div style={styles.profile}>

        <img
          src={userData.avatar || "https://via.placeholder.com/100"}
          style={styles.avatar}
        />

        {/* онлайн точка */}
<div style={{ marginTop: 6, textAlign: "center" }}>
  <div
    style={{
      width: 10,
      height: 10,
      borderRadius: "50%",
      background: userData.online ? "#00ff6a" : "#555",
      margin: "0 auto"
    }}
  />

  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
    {userData.online
      ? "в сети"
      : userData.lastSeen
      ? `был(а) ${formatLastSeen(userData.lastSeen)}`
      : "был(а) давно"}
  </div>
</div>

        <h2 style={{ marginTop: 10 }}>
          {userData.name || "Без имени"}
        </h2>

        <p style={{ opacity: 0.6, marginTop: -5 }}>
          @{username}
        </p>

        <div style={styles.statusGlassBig}>
  {userData.status && userData.status.trim() !== ""
    ? userData.status
    : "без статуса"}
</div>

        {/* 📄 био */}
        <div style={styles.bioBox}>
          {userData.bio || "Нет информации"}
        </div>

        {/* 🔥 статус контакта */}
        <div style={{
          marginTop: 10,
          fontSize: 13,
          color: isContact ? "#4caf50" : "#888"
        }}>
          {isContact ? "в контактах" : "не в контактах"}
        </div>

      </div>

        {/* 🧩 ПОСТЫ */}
        <div style={styles.grid}>
          {(userData.posts || []).map((p, i) => (
            <div
              key={i}
              onClick={() => {
                setPostModal({
                  posts: userData.posts,
                  index: i,
                  ownerUsername: username
                });
              }}
            >
              <img src={p.image} style={styles.postImg} />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

const styles = {
  container: {
    color: "#fff",
    background: "#1e1e1e",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center"
  },

  content: {
    width: "100%",
    maxWidth: 700,
    padding: 15
  },

  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20
  },

  leftBtns: {
    display: "flex",
    gap: 10
  },

  glassBtn: {
    padding: "8px 12px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(8px)",
    color: "#fff",
    fontSize: 13,
    cursor: "pointer",
    transition: "all 0.2s ease"
  },

  dangerBtn: {
    padding: "8px 12px",
    borderRadius: 12,
    border: "1px solid rgba(255,80,80,0.4)",
    background: "rgba(255,80,80,0.1)",
    color: "#ff6b6b",
    cursor: "pointer"
  },

  profile: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: 6
},

  avatar: {
    width: 110,
    borderRadius: "50%"
  },

  statusGlass: {
    marginTop: 10,
    padding: "6px 12px",
    borderRadius: 12,
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.2)"
  },

  friendLabel: {
    marginTop: 10,
    fontSize: 12,
    color: "#4caf50"
  },

  grid: {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 10,
  marginTop: 25
},

  postImg: {
    width: "100%",
    aspectRatio: "1/1",
    objectFit: "cover",
    borderRadius: 8,
    cursor: "pointer"
  },

  friendLabel: {
  marginTop: 10,
  fontSize: 12,
  color: "#4caf50",
  transition: "all 0.3s ease",
  transform: "scale(1)",
},

statusGlassBig: {
  marginTop: 12,
  padding: "10px 16px",
  borderRadius: 14,

  background: "rgba(255,255,255,0.08)",
  border: "1px solid rgba(255,255,255,0.15)",
  backdropFilter: "blur(10px)",

  fontSize: 14,
  color: "#ddd",
  width: "100%",
  textAlign: "center"
},

bioBox: {
  marginTop: 12,
  width: "100%",

  padding: 12,
  borderRadius: 14,

  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.1)",

  color: "#ccc",
  textAlign: "center"
},

pageEnter: {
  opacity: 0,
  transform: "translateY(20px)",
  animation: "fadeInPage 0.4s ease forwards"
},

};

export default UserPage;